import React from 'react';

import { AuthProvider } from './AuthContext';
import { GlobalProvider } from './GlobalContext';
import { LanguageProvider } from './LanguageContext';
import { LayoutProvider } from './LayoutContext';
import { ThemeProvider } from './ThemeContext';
import { TimerProvider } from './TimerContext';
import { UserConfigProvider } from './UserConfigContext';
import { WebSocketProvider } from './WebSocketContext';

type ProviderComponent = React.ComponentType<{ children: React.ReactNode }>;

const defaultProviders: ProviderComponent[] = [
  LayoutProvider,
  AuthProvider,
  UserConfigProvider,
  WebSocketProvider,
  ThemeProvider,
  GlobalProvider,
  LanguageProvider,
  TimerProvider,
];

interface ICombinedContextProviderProps {
  children: React.ReactNode;
}

export default function CombinedContextProvider(
  providers: ProviderComponent[] = defaultProviders,
): ProviderComponent {
  return providers.reduce(
    (AccumulateProviders, CurrentProvider) => {
      return ({ children }: ICombinedContextProviderProps) => {
        return (
          <AccumulateProviders>
            <CurrentProvider>{children}</CurrentProvider>
          </AccumulateProviders>
        );
      };
    },
    ({ children }: ICombinedContextProviderProps) => <>{children}</>,
  );
}
